import type { SVGProps } from "react";
const SvgLogoDoorLeftNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={567.999}
    height={164.001}
    fill="none"
    fillRule="evenodd"
    stroke="#000"
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    strokeWidth={0.501}
    fontFamily="Times New Roman"
    fontSize={16}
    overflow="visible"
    style={{
      fontVariantLigatures: "none",
    }}
    viewBox="271.168 -561.798 425.999 123.001"
    {...props}
  >
    <g stroke="none">
      <path
        fill="#7c7268"
        d="m571.168-438.797 122.999-122.991v-.01h3v.01L574.168-438.797z"
      />
      <path
        fill="#f7e5c5"
        d="M271.168-438.797v-123.001h422.999v.01L571.168-438.797z"
      />
      <g
        fill="#262626"
        fillRule="nonzero"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.416}
      >
        <path d="M364.198-528.135q0-.672-.28-.952t-1.064-.28h-21.056q-1.344 0-1.904-.504t-.56-1.96v-5.712q0-1.456.56-1.96t1.904-.504h56q1.344 0 1.904.504t.56 1.96v5.712q0 1.456-.56 1.96t-1.904.504h-21.056q-.784 0-1.064.28t-.28.952v64.064q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96zM411.823-537.543q0-1.456.56-1.96t1.904-.504h6.272q1.344 0 1.904.504t.56 1.96v29.12q0 .672.28 1.008t1.064.336h37.072q.784 0 1.064-.336t.28-1.008v-29.12q0-1.456.56-1.96t1.904-.504h6.272q1.344 0 1.904.504t.56 1.96v73.472q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96v-31.248q0-.672-.28-.952t-1.064-.28h-37.072q-.784 0-1.064.28t-.28.952v31.248q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96zM493.69-537.543q0-1.456.56-1.96t1.904-.504h6.272q1.344 0 1.904.504t.56 1.96v73.472q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96zM521.004-478.519q.895-1.232 1.68-1.232.56 0 1.68.896 10.192 7.952 20.496 7.952 5.152 0 8.96-1.456 3.808-1.457 5.88-4.2t2.072-6.328q0-3.473-1.68-5.712-1.68-2.24-5.432-3.864-3.751-1.624-10.584-3.416-8.064-2.016-13.272-4.704t-8.064-7-2.856-10.808q0-7.056 3.472-12.208t9.464-7.896 13.496-2.744q14.112 0 25.536 8.848.56.448.84.84t.28.84q0 .336-.224.784t-.56 1.008l-3.248 4.816q-.448.672-.84.952t-.84.28q-.784 0-1.904-.784-4.48-3.248-9.184-5.152t-9.968-1.904q-4.255 0-7.56 1.4t-5.152 4.032-1.848 6.216 1.848 5.936 5.488 3.92 9.912 3.136q8.624 2.24 13.944 5.04t7.952 7 2.632 10.36q0 6.943-3.696 12.264t-10.192 8.176q-6.496 2.856-14.896 2.856-7.615 0-14.28-2.576a46.1 46.1 0 0 1-12.264-7.056q-1.232-1.12-1.232-1.904t.784-1.904z" />
      </g>
    </g>
  </svg>
);
export default SvgLogoDoorLeftNew;
